import { api } from "./config/axios";

class _AlgorithmAPI {
    route = 'algorithm';

    getNode = async (id: string) => {
        const response = await api.request({
            url: `/${this.route}/nodes/${id}/`,
            method: 'GET'
        })

        return response;
    }

    getAllNodes = async () => {
        const response = await api.request({
            url: `/${this.route}/nodes/`,
            method: 'GET'
        })

        return response;
    }

    getEdge = async (id: string) => {
        const response = await api.request({
            url: `/${this.route}/edges/${id}/`,
            method: 'GET'
        })

        return response;

    }

    getAllEdges = async () => {
        const response = await api.request({
            url: `/${this.route}/edges/`,
            method: 'GET'
        })

        return response;
    }
}

export const AlgorithmAPI = new _AlgorithmAPI();